import React from "react";
import { useSelector } from "react-redux";

const CancellationPolicy = () => {
  const TourDetails = useSelector((state) => state.packageDetail.TourDetails);

  return (
    <div dangerouslySetInnerHTML={{ __html: TourDetails?.CancellationPolicy || "" }} />
  );
};

export default CancellationPolicy;
